import { Grid2 as Grid, TextField, Typography } from '@mui/material'

const TextFieldContent = () => {
    return (
        <>
            <Grid container spacing={2} sx={{ mb: 2 }}>
                <Grid size={12}>
                    <Typography variant="h3" gutterBottom>
                        Default text fields
                    </Typography>
                    <code>{`<TextField label="Outlined" variant="outlined" sx={{ width: '100%' }} />`}</code>
                    <br />
                    <code>{`<TextField label="Filled" variant="filled" sx={{ width: '100%' }} />`}</code>
                    <br />
                    <code>{`<TextField label="Standard" variant="standard" sx={{ width: '100%' }} />`}</code>
                    <br />
                </Grid>
                <Grid size={4}>
                    <TextField
                        label="Outlined"
                        variant="outlined"
                        sx={{ width: '100%' }}
                    />
                </Grid>
                <Grid size={4}>
                    <TextField
                        label="Filled"
                        variant="filled"
                        sx={{ width: '100%' }}
                    />
                </Grid>
                <Grid size={4}>
                    <TextField
                        label="Standard"
                        variant="standard"
                        sx={{ width: '100%' }}
                    />
                </Grid>
            </Grid>
        </>
    )
}

export default {
    content: <TextFieldContent />,
    slug: 'text-fields',
    title: 'Text Fields'
}
